import React from 'react';
import { classes } from './ServiceInfo.st.css';
import { ViewModel } from '../../../../controller/viewModel/viewModel';
import { ServiceDescription } from './ServiceDescription/ServiceDescription';
import { ServiceTitle } from './ServiceTitle/ServiceTitle';
import { ServiceNumber } from './ServiceNumber/ServiceNumber';

export const ServiceInfo: React.FC<{
  service: ViewModel['bodyViewModel']['services'][number];
  index: number;
}> = ({ service, index }) => {
  return (
    <div data-id={service.id} role="group" className={classes.root}>
      <div className={classes.header}>
        <ServiceNumber index={index} />
        <ServiceTitle title={service.name} />
      </div>

      {service.description && (
        <ServiceDescription description={service.description} />
      )}
    </div>
  );
};
